export class ApplicationStatus {
    code: string;
    name: string;
    sortOrder: number;
}


// WEBPACK FOOTER //
// ./src/app/models/applicationStatus.ts